import { createAction } from 'redux-actions';

// ------------------------------------
// Actions
// ------------------------------------
export const getJobRolesHash: any = createAction('skills/GET_JOBROLES_HASH', (jobRoles: State.JobRoles) => () => {
  return jobRoles;
});
